module.exports = __webpack_public_path__ + "static/media/13.912a7e19.JPG";